module.exports = __webpack_public_path__ + "img/bg-bar.99a143e9.jpg";